import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axios"; 
import { useAuth } from "../context/AuthContext";

const colors = {
  brand: "#6D9BC3",
  bg: "#F0F4F7",
  card: "#ffffff",
  text: "#2b2d42",
  muted: "#8d99ae",
  border: "#edf2f7",
  indicator: "#4cc9f0" 
};

function ChatList() {
  const [chats, setChats] = useState([]);
  const { user, socket } = useAuth();
  const navigate = useNavigate();

  // 1. Fetch Chat Hubs
  const fetchChats = async () => {
    try {
      const res = await api.get("/api/chat/list");
      setChats(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Hub Sync Error:", err);
      setChats([]);
    }
  };

  useEffect(() => {
    if (user) fetchChats();
  }, [user]);

  // 2. Real-time Badge Updates
  useEffect(() => {
    if (!socket) return;

    const handleUpdate = () => {
      fetchChats(); 
    };

    socket.on("newMessage", handleUpdate);
    socket.on("unreadUpdate", handleUpdate);
    socket.on("chat:seen", handleUpdate);

    return () => {
      socket.off("newMessage", handleUpdate);
      socket.off("unreadUpdate", handleUpdate);
      socket.off("chat:seen");
    };
  }, [socket]);

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>
        {user?.role === "admin" ? "Active Node Inquiries" : "Service Inquiries"}
      </h2>

      {chats.length === 0 ? (
        <div style={styles.empty}>No active inquiry history found.</div>
      ) : (
        <div style={styles.list}>
          {chats.map((c) => {
            const hasUnread = user?.role === "admin" ? c.unreadByAdmin : c.unreadByUser;
            const displayName = user?.role === "admin" 
                ? (c.user?.email || c.user?.node_id || "Unknown Node") 
                : "System Dispatch";

            return (
              <div
                key={c._id}
                style={styles.item}
                onClick={() => navigate(user?.role === "admin" ? `/admin/chat/${c.user?._id}` : `/chat`)}
              >
                <div style={styles.left}>
                  <div style={styles.avatar}>
                    <span style={{fontSize: '10px', fontWeight: 'bold', color: colors.muted}}>
                        {user?.role === "admin" ? "NODE" : "HQ"}
                    </span>
                  </div>
                  <div style={{display: 'flex', flexDirection: 'column'}}>
                    <span style={styles.nameLabel}>{displayName}</span>
                    {c.lastMessage && (
                        <span style={{fontSize: '12px', color: colors.muted, maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                            {c.lastMessage}
                        </span>
                    )}
                  </div>
                </div>

                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    <span style={{fontSize: '10px', color: colors.muted}}>
                        {new Date(c.lastTransmission || c.updatedAt).toLocaleDateString()}
                    </span>
                    {hasUnread && <div style={styles.unread} />}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const styles = {
  container: { padding: "25px", maxWidth: "800px", margin: "0 auto", minHeight: "80vh", fontFamily: "sans-serif" },
  title: { marginBottom: "25px", fontSize: "20px", color: colors.text, fontWeight: "700", textTransform: "uppercase", letterSpacing: "1px" },
  list: { background: colors.card, borderRadius: "12px", border: `1px solid ${colors.border}`, overflow: "hidden", boxShadow: "0 2px 10px rgba(0,0,0,0.05)" },
  item: { padding: "16px 20px", borderBottom: `1px solid ${colors.border}`, cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", transition: "background 0.2s ease" },
  left: { display: "flex", alignItems: "center", gap: "15px" },
  avatar: { width: "44px", height: "44px", borderRadius: "10px", background: colors.bg, display: "flex", alignItems: "center", justifyContent: "center", border: `1px solid ${colors.border}` },
  nameLabel: { fontSize: "15px", fontWeight: "700", color: colors.text },
  unread: { width: "12px", height: "12px", borderRadius: "50%", background: colors.brand, boxShadow: `0 0 10px ${colors.brand}88` },
  empty: { textAlign: "center", color: colors.muted, marginTop: "60px", fontSize: "14px", padding: '40px', border: `2px dashed ${colors.border}`, borderRadius: '12px' }
};

export default ChatList;